import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface AccordionProps {
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
}
export const Accordion: React.FC<AccordionProps> = ({
  title,
  children,
  defaultOpen = false
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  return <div className="border border-slate-700/50 rounded-lg bg-[#112236] overflow-hidden mb-3" data-id="element-235">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-4 text-left font-bold text-white hover:bg-[#162a42] transition-colors" data-id="element-236">
        <span className="pr-4" data-id="element-237">{title}</span>
        <ChevronDown className={`w-5 h-5 text-[#f0b429] flex-shrink-0 transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-238" />
      </button>
      <AnimatePresence data-id="element-239">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} className="overflow-hidden" data-id="element-240">
            <div className="p-4 pt-0 text-slate-300 text-sm md:text-base" data-id="element-241">
              {children}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
};